"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _themeProviderModule = _interopRequireDefault(require("./theme-provider.module.scss"));
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  (0, _react.useEffect)(function () {
    if (enabled) {
      document.body.classList.add(_themeProviderModule.default['yordex-theme']);
    } else {
      document.body.classList.remove(_themeProviderModule.default['yordex-theme']);
    }
  }, [enabled]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
exports.ThemeProvider = ThemeProvider;